function catt_drawer_open(test) {
  const cart_drawer = document.querySelector('[data-custom-cart-drawer]') || null;
  if(test){
    if(cart_drawer.classList.contains("isopen")) return;
  }
  if(cart_drawer){
    cart_drawer.classList.toggle('isopen');
    document.body.classList.toggle('cart_drawer_open')
  }
}
function cart_drawer_close() {
  const cart_drawer = document.querySelector('[data-custom-cart-drawer]') || null;
  if(cart_drawer){
    cart_drawer.classList.remove('isopen');
      document.body.classList.remove('cart_drawer_open')
  }
}

function cart_drawer_selection() {
  const close_cart_drawer = document.querySelectorAll('[data-cart-drawer-close]') || null;
  if(close_cart_drawer){
    close_cart_drawer.forEach((button) =>{
      button.addEventListener("click",function(e) {
        e.preventDefault();
        cart_drawer_close();
      })
    });
  }
}
function empty_cart_close() {
  const close_empty_drawer = document.querySelectorAll('[closed-drawer]') || null;
  if(close_empty_drawer){
        cart_drawer_close();
  }
  // console.log("close_empty_drawer",close_empty_drawer);
}
function cart_drawer_selection_open() {
  const open_cart_drawer = document.querySelectorAll('[data-custom-drawer-toggel]') || null;
  if(open_cart_drawer){
    open_cart_drawer.forEach((button) =>{
          button.addEventListener("click",function(e) {
                  e.preventDefault();
                 catt_drawer_open();
                });
        });
  }
}

(function() {
cart_drawer_selection();
  cart_drawer_selection_open();
  empty_cart_close();
})();